// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__6h4Uy","mobile":"styles_mobile__Yxtiq"};